import { css } from "styled-components";

export const FontStyle = css`
  font-family: -apple-system, BlinkMacSystemFont, "Roboto", "Helvetica Neue",
    Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;
